import { api } from "@/shared/libs/axiosClient";

export interface WebhookTokenResponse {
  has_token: boolean;
  webhook_token?: string;
}

export async function getWebhookToken(teamId: number): Promise<WebhookTokenResponse> {
  return api.get<WebhookTokenResponse>(`/team/${teamId}/webhook-token`);
}

export async function generateWebhookToken(teamId: number): Promise<WebhookTokenResponse> {
  return api.post<WebhookTokenResponse>(`/team/${teamId}/webhook-token`);
}

export async function deleteWebhookToken(teamId: number): Promise<WebhookTokenResponse> {
  return api.delete<WebhookTokenResponse>(`/team/${teamId}/webhook-token`);
}
